import { FliptClient } from "@flipt-io/flipt-client-js";

let fliptClientInstance: FliptClient | null = null;

export const getFliptClient = async (): Promise<FliptClient> => {
  if (fliptClientInstance) {
    return fliptClientInstance;
  }

  fliptClientInstance = await FliptClient.init({
    url: import.meta.env.VITE_APP_FLIPT_URL,
    namespace: import.meta.env.VITE_APP_PROJECT_NAME || "default",
    authentication: {
      clientToken: import.meta.env.VITE_APP_FLIPT_TOKEN || undefined,
    },
  });

  return fliptClientInstance;
};
